export default () => ({
  version: '0.0.1',
  auth: {
    isLoggedIn: false
  }
})



// WEBPACK FOOTER //
// ./src/vuex/state/initial_state.js